import React, {ReactNode, useState} from 'react';
import {useQueryParams} from "@hooks/query/useQueryParams";
import {useExportParams} from "@containers/export/containers/buildData/hooks/useExportParams";
import {useTranslateArray} from "@labels/hooks/useTranslateArray";
import {MapperRowCbType} from "@ui/tableCustom/types/table";
import ItemTableTaskSingleVoyage from "./item/ItemTableTaskSingleVoyage";
import ActionUiHandler from "@ui/template/actionUiHandler/ActionUiHandler";
import TableCustom from "@ui/tableCustom/TableCustom";
import {
	TaskSingleVoyageRowForTable,
	TaskSingleVoyageTransformForTable,
	TaskWayPointSingleVoyage
} from "@containers/singleVoyage/tasks/table/types";
import {OnDeleteTaskSingleVoyage, OnSaveTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import {
	FULL_COLUMNS_SUB_TASKS_SINGLE_VOYAGE,
	FULL_COLUMNS_TASKS_SINGLE_VOYAGE
} from "@containers/singleVoyage/tasks/table/constants/fullColumns";
import HeadSidebarTableTasksSingleVoyage
	from "@containers/singleVoyage/tasks/table/headSidebar/HeadSidebarTableTasksSingleVoyage";
import {
	useTransformTableTasksSingleVoyage
} from "@containers/singleVoyage/tasks/table/hooks/useTransformTableTasksSingleVoyage";


interface IProps {
	voyageId: number
	accountId: string | number
	tasks: TaskSingleVoyageRowForTable[]
	onSave?: OnSaveTaskSingleVoyage
	onDelete?: OnDeleteTaskSingleVoyage
	isLoading?: boolean
	onRefetch?: () => void
	disableRefetch?: boolean
	isPending?: boolean
	waypoints: TaskWayPointSingleVoyage[]
	headSidebar?: ReactNode
}

const TableTasksSingleVoyages = ({
									 voyageId,
									 tasks,
									 isLoading,
									 onSave,
									 onDelete,
									 onRefetch,
									 isPending,
									 waypoints,
									 accountId,
									 headSidebar,
									 disableRefetch,
								 }: IProps) => {
	
	const [targetWaypointIds, setTargetWaypointIds] = useState<string[]>([])
	
	const fullColumns = useTranslateArray({array: FULL_COLUMNS_TASKS_SINGLE_VOYAGE})
	const subtasksFullColumns = useTranslateArray({array: FULL_COLUMNS_SUB_TASKS_SINGLE_VOYAGE})
	
	const params = useQueryParams<TaskSingleVoyageTransformForTable>({
		initialOrder: 'title',
		initialDirection: 'ASC',
	})
	
	const exportParams = useExportParams<TaskSingleVoyageTransformForTable>({
		initialExportDataFromAllPage: true,
	})
	
	const {
		transformData,
		isFetchingTransform,
		isLoadingTransform,
	} = useTransformTableTasksSingleVoyage({
		tasks,
		waypoints,
		targetWaypointIds,
		accountId,
	})
	
	const mapperRowCb: MapperRowCbType<TaskSingleVoyageTransformForTable> = React.useCallback(({
																								   content,
																								   exportFeaturesProps
																							   }) => {
		return (
			<ItemTableTaskSingleVoyage
				key={content?.id}
				content={content}
				exportFeaturesProps={exportFeaturesProps}
				fullColumns={fullColumns}
				onSave={onSave}
				voyageId={voyageId}
				waypoints={waypoints}
				onDelete={onDelete}
				accountId={accountId}
				subtasksFullColumns={subtasksFullColumns}
			/>
		)
	}, [
		transformData,
		fullColumns,
		subtasksFullColumns,
		tasks,
		onSave,
		voyageId,
		waypoints,
		onDelete,
		accountId,
	])
	
	
	return (
		<ActionUiHandler
			isLoading={isLoading || isPending || isFetchingTransform || isLoadingTransform}
		>
			<TableCustom
				<TaskSingleVoyageTransformForTable>
				autoGenerateExportData={['data']}
				fullColumns={fullColumns}
				mapperRowCb={mapperRowCb}
				exportParams={exportParams}
				params={params}
				data={transformData}
				hasLocalFilters
				headSideBar={<HeadSidebarTableTasksSingleVoyage
					params={params}
					onRefetch={onRefetch}
					voyageId={voyageId}
					onSave={onSave}
					waypoints={waypoints}
					targetWaypointIds={targetWaypointIds}
					setTargetWaypointIds={setTargetWaypointIds}
					accountId={accountId}
					disableRefetch={disableRefetch}
				>
					{headSidebar}
				</HeadSidebarTableTasksSingleVoyage>}
			/>
		</ActionUiHandler>
	);
};

export default TableTasksSingleVoyages;
